import { messageBoardConstants } from './constants/messageBoardConstants';

 const messageBoardSave = (messageInput: any) => {
    return {
		type: messageBoardConstants.MessageBoard_Save_Request,
        input: messageInput
    }; 
};

 const messageBoardGetDetail = (id: any) => {
    return {
		type: messageBoardConstants.MessageBoard_GetDetail_Request,
        input: { id: id }
    };
};

 const messageBoardGetByFilter = () => {
	return {
		type: messageBoardConstants.MessageBoard_GetByFilter_Request,

    };
};

const messageBoardDelete = (id: any) => {
	return {
		type: messageBoardConstants.MessageBoard_Delete_Request,
		input: { id: id }
	};
};

 const messageBoardGetReport = (id, startDateUtc, endDateUtc) => {
	return {
		type: messageBoardConstants.MessageBoard_GetReport_Request,
		input: {reportGetInput: { messageBoardId: id, startDateUtc: startDateUtc, endDateUtc: endDateUtc }}
	};
};

 const messageBoardGetTopicByFilter = (input: any) => {
	return {
		type: messageBoardConstants.MessageBoard_GetTopic_Request,
		input: input
	};
};

 const messageBoardTopicDelete = (id: any) => {
	return {
		type: messageBoardConstants.MessageBoard_TopicDelete_Request,
		input: id
	};
};

const messageBoardTopicRestore = (id: any) => {
	return {
		type: messageBoardConstants.MessageBoard_TopicRestore_Request,
		input: id
	};
};

 const messageBoardGetPostByFilter = (input: any) => {
	return {
		type: messageBoardConstants.MessageBoard_GetPostByFilter_Request,
		input: input
	};
};

 const messageBoardGetAlert = (input: any) => {
	return {
		type: messageBoardConstants.MessageBoard_GetAlert_Request,
		input: input
	};
};

 const messageBoardPostDelete = (id: any) => {
	return {
		type: messageBoardConstants.MessageBoard_PostDelete_Request,
		input: id
	};
};

const messageBoardPostRestore = (id: any) => {
	return {
		type: messageBoardConstants.MessageBoard_PostRestore_Request,
		input: id
	};
};

 const messageBoardPostFlag = (input: any) => {
	return {
		type: messageBoardConstants.MessageBoard_PostFlag_Request,
		input: input
	};
};

const messageBoardPostAuthorization = (input: any) => {
	return {
		type: messageBoardConstants.MessageBoard_PostAuthorization_Request,
		input: input
	};
};

 const messageBoardGetReportType = () => {
	return {
		type: messageBoardConstants.MessageBoard_GetReportType_Request
	};
};

 const messageBoardGetCountByYear = (input) => {
	return {
		type: messageBoardConstants.MessageBoard_GetCountByYear_Request,
		input: input
	};
};

 const messageBoardGetPublicMessageByUserId = (input) => {
	return {
		type: messageBoardConstants.MessageBoard_GetUserPublicMessage_Request,
		input: input
	};
};

 const messageBoardGetChannelMessageByUserId = (input) => {
	return {
		type: messageBoardConstants.MessageBoard_GetUserChannelMessage_Request,
		input: input
	};
};

export const messageBoardAction = {
	messageBoardSave,
	messageBoardGetDetail,
	messageBoardDelete,
	messageBoardGetByFilter,	
	messageBoardGetReport,
	messageBoardGetTopicByFilter,
	messageBoardTopicDelete,
	messageBoardTopicRestore,
	messageBoardGetPostByFilter,
	messageBoardGetAlert,
	messageBoardPostDelete,
	messageBoardPostRestore,
	messageBoardPostFlag,
	messageBoardPostAuthorization,
	messageBoardGetReportType,
	messageBoardGetCountByYear,
	messageBoardGetPublicMessageByUserId,
	messageBoardGetChannelMessageByUserId,
}